import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { scrollToId } from "../lib/api";

const LINKS = [
  { label: "The Chapters", id: "guides" },
  { label: "Decision Tool", id: "decision-tool" },
  { label: "Calculator", id: "calculator" },
  { label: "Companies", id: "companies" },
  { label: "Pricing", id: "pricing" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-navbar"
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color] duration-500 border-b ${
        scrolled
          ? "bg-white/70 backdrop-blur-xl border-border saturate-150"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-serif text-xl md:text-2xl tracking-tight text-primary"
        >
          The Timeshare <em className="text-accent">Edit</em>
        </button>
        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="text-sm font-semibold tracking-wide text-foreground/70 hover:text-primary transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-consult"
            onClick={() => scrollToId("consult")}
            className="group flex items-center gap-2 bg-primary text-primary-foreground text-sm font-semibold px-6 py-2.5 rounded-full hover:bg-accent transition-colors duration-300"
          >
            Get Guidance
            <ArrowUpRight size={16} weight="bold" className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </nav>
        <button
          data-testid="nav-cta-consult-mobile"
          onClick={() => scrollToId("consult")}
          className="md:hidden bg-primary text-primary-foreground text-sm font-semibold px-5 py-2 rounded-full"
        >
          Consult
        </button>
      </div>
    </motion.header>
  );
}
